// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { isCustomerTemplateKey } from '../../../../utils/templates/is-customer-template.tsx';
import type { State } from '../../types.tsx';
import { performGetProjectPropertiesRequest } from './utils.tsx';

export const fetchProjectProperties =
	(projectId: string): Action<State> =>
	async ({ getState, setState }) => {
		const currentState = getState();

		const currentStateForProjectId = currentState[projectId];

		if (
			currentStateForProjectId?.fetchStatus === 'fetched' ||
			currentStateForProjectId?.fetchStatus === 'fetching'
		) {
			return;
		}

		setState({
			[projectId]: { ...currentStateForProjectId, fetchStatus: 'fetching' },
		});

		const response = await performGetProjectPropertiesRequest({
			projectId,
		});

		if (response) {
			const templateKey = response['initial.project.template.name'];

			const isCustomerTemplateProject =
				typeof templateKey === 'string' && isCustomerTemplateKey(templateKey);

			setState({
				[projectId]: {
					fetchStatus: 'fetched',
					isCustomerTemplateProject,
					templateKey,
				},
			});
		}
	};
